<template>
    <div class="mb-5">
        <div style="display: flex; justify-content: space-between" class="mb-2">
            <h4>JA Campaigns</h4>
            <btn v-if="! readonly" :click="createJaCampaign" icon="fas fa-plus">New JA campaign</btn>
        </div>

        <p v-if="ja_campaigns.length == 0">No JA campaigns have been created.</p>
        <div class="table-responsive" v-else>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="tb-br">Name</th>
                        <th class="tb-br">P</th>
                        <th class="tb-la"># dials</th>
                        <th class="tb-la"># answers</th>
                        <th class="tb-la"># sent to ATS</th>
                        <th class="tb-la">sent to ATS/dials</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="c in ja_campaigns">
                        <td class="tb-br">
                            <a :href="url(`/jam/cards/${c.id}/detail`)" v-if="!c.deleted_at && c.id">{{ c.name }}</a>
                            <template v-if="!c.id">{{ c.name }}</template>

                            <template v-if="c.deleted_at">
                                {{ c.name }} <span class="ml-2 badge badge-light" style="font-size: 85%">Deleted</span>

                                <btn v-if="! readonly" cssClass="btn btn-sm btn-default" icon="fas fa-undo" :click="() => undeleteJaCampaign(c.id)" style="float: right">
                                    Undelete
                                </btn>
                            </template>
                        </td>
                        <td>{{ c.priority }} </td>
                        <td class="tb-la">{{ c.dials }} </td>
                        <td class="tb-la">{{ c.answers }} </td>
                        <td class="tb-la">{{ c.sent_to_ats }} </td>
                        <td class="tb-la">{{ c.rate }} </td>
                    </tr>
                </tbody>
                <tfoot v-if="sums">
                    <tr>
                        <th class="tb-br">Total</th>
                        <th></th>
                        <th class="tb-la">{{ sums.dials_total }}</th>
                        <th class="tb-la">{{ sums.answers_total }}</th>
                        <th class="tb-la">{{ sums.sent_to_ats_total }}</th>
                        <th class="tb-la"></th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'fulfillment',
            'ja_campaigns',
            'sums',
            'readonly',
        ],
        methods: {
            createJaCampaign() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/ja-campaign/create`))
                    .then((response) => {
                        window.location.href = url(`/jam/cards/${response.data.agent_campaign_id}/detail`);
                    })
            },
            undeleteJaCampaign(cardId) {
                return axios.post(url(`ja/campaign/${cardId}/undelete`))
                    .then(() => {
                        this.$emit('changed');
                    })
            },
        },
    }
</script>

<style>
    .tb-br {
        border-right: 1px solid #dee2e6;
    }
    .tb-la {
        text-align: right;
    }
    .el-dialog h4 {
        font-size: 18px;
    }
</style>